module.exports = __webpack_public_path__ + "static/media/professional.e675dd28.svg";